module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.964dae65.otf";